// Font optimization utilities
export const loadFonts = () => {
    // Only load fonts if they haven't been loaded already
    if (document.fonts && document.fonts.ready) {
        return document.fonts.ready;
    }

    // Fallback for older browsers
    return Promise.resolve();
};

// Font loading with fallback strategy
export const createFontFace = (fontFamily, fontPath, fontWeight = 'normal', fontStyle = 'normal') => {
    if (typeof FontFace !== 'undefined') {
        const font = new FontFace(fontFamily, `url(${fontPath})`, {
            weight: fontWeight,
            style: fontStyle,
            display: 'swap' // Prevents layout shift
        });

        return font.load().then(() => {
            document.fonts.add(font);
            return font;
        }).catch(err => {
            console.warn(`Failed to load font: ${fontPath}`, err);
            return null;
        });
    }

    return Promise.resolve(null);
};

// Critical font loading
export const loadCriticalFonts = () => {
    const criticalFonts = [
        // Add only the fonts you actually use
        // Example: { family: 'GalanoGrotesque', path: '/fonts/GalanoGrotesqueRegular.woff2', weight: '400' }
    ];

    return Promise.all(
        criticalFonts.map(font =>
            createFontFace(font.family, font.path, font.weight, font.style)
        )
    );
};

// Font fallback strategy
export const getFontFallback = (fontFamily) => {
    const fallbacks = {
        'Inter': '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        'GalanoGrotesque': '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        'Montserrat': '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    };

    return fallbacks[fontFamily] || 'sans-serif';
}; 